import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { navigationUrl } from '../../../store/analytic/actions';
import Modal from '../index';

import { Content } from './styles';


interface IMessage{
    handlerClose:()=>void
}

function ScheduleCallModal({ handlerClose }:IMessage){
  const dispatch = useDispatch();
  
  useEffect(() => {
    dispatch(navigationUrl.request({
        action: "Modal enviar uma mensagem"
    }))
  },[dispatch]);

  
  return (
    <Modal title={'Enviar uma Mensagem'} handlerClose={handlerClose} width={window.matchMedia("(max-width: 960px)").matches ? "360px" : "464px"} >
      <Content >
        <div>Oi</div>
      </Content >
    </Modal>  
  );
};

export default ScheduleCallModal;

